import { render, staticRenderFns } from "./OpenTurn.vue?vue&type=template&id=3397a53b"
import script from "./OpenTurn.vue?vue&type=script&lang=js"
export * from "./OpenTurn.vue?vue&type=script&lang=js"
import style0 from "./OpenTurn.vue?vue&type=style&index=0&id=3397a53b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports